import {
  Box,
  Button,
  Card,
  Grid,
  IconButton,
  Stack,
  Typography,
  Dialog,
  TextField,
  Tooltip,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Icon,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tabs,
  Tab,
  Switch,
  FormGroup,
  FormControlLabel,
  FormLabel,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import CommonLayout from "layouts/DashboardLayout";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import Search from "examples/Search";
import MDButton from "components/MDButton";
import {
  closeCustomModalDialog,
  openCustomModalDialog,
  setModalLoader,
} from "../../../redux/slices/modalSlice";
import Zoom from "react-medium-image-zoom";
import { useDispatch, useSelector } from "react-redux";
import AngleRightIcon from "common/customIcons/angle_right";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { grey } from "@mui/material/colors";
import { AgGridTable } from "components/tables/AgGridTable";
import { Link, useNavigate, useParams } from "react-router-dom";
import EditIcon from "common/customIcons/edit";
import DeleteIcon from "common/customIcons/delete";
import { OpenInNewSharp } from "@mui/icons-material";
import colors from "assets/theme/base/colors";
import { deleteBanner, getHomepageBanners, openSnackbar } from "../../../redux/slices/common";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import CommonQuillEditor from "common/editor";
import InboxIcon from "@mui/icons-material/Inbox";
import MyAccountIcon from "common/customIcons/myAccount";
import ContactUsIcon from "common/customIcons/contactUs";
import BrandsIcon from "common/customIcons/brands";
import DragIcon from "common/customIcons/dragIcon";
import { useSearchParams } from "react-router-dom";

import { getData } from "utilities/common";
import { stateList } from "utilities/common";
import NoDataFound from "common/component/NoDataFound";
import Loader from "common/Loader";
import { getHomePageById } from "../../../redux/slices/homePage";
import ActiveIcon from "common/customIcons/active";
import InActiveIcon from "common/customIcons/inactive";
import defaultImage from "assets/images/placeholder-image.png";
import MDBox from "components/MDBox";
import { capitalizeText } from "utilities/common";

export default function ViewHome({ isDefaultHomePage = false }) {
  const user = getData("login-user-info");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const settingName = formatStateName(searchParams.get("statename"));
  const [stateName, setStateName] = useState(settingName);

  const stateValue = searchParams.get("statename");
  const matchedState = stateList.find((item) => item.value === stateValue);
  const parseUser = JSON.parse(user);
  const mainGridApiRef = useRef("");
  const { banners = {}, isLoading: loading = false } = useSelector((state) => state.common);
  const pageRef = useRef(0);
  const gridRefApi = useRef(null);
  const { id } = useParams();
  const { loading: getLoading = false, homePageData = {} } = useSelector((state) => state.homePage);
  const { text } = colors;
  const [copyStatus, setCopyStatus] = useState("");

  const thumbnail = {
    maxWidth: "100px",
    height: "70px",
    borderRadius: "6px",
    objectFit: "cover",
  };
  const linkStyle = {
    color: text.main,
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
  };

  const siteMapData = [
    {
      icon: "",
      name: "My Account",
      link: "https://hyperwolf.com/login",
    },
    {
      icon: "",
      name: "Contact",
      link: "https://hyperwolf.com/login",
    },
    {
      icon: "",
      name: "Brands",
      link: "https://hyperwolf.com/login",
    },
    {
      icon: "",
      name: "Strains",
      link: "https://hyperwolf.com/login",
    },
    {
      icon: "",
      name: "My Account",
      link: "https://hyperwolf.com/login",
    },
    {
      icon: "",
      name: "Blog",
      link: "https://hyperwolf.com/login",
    },
  ];

  useEffect(() => {
    // console.log(isDefaultHomePage, "aaaaaaaaaa");
    setFormData({ ...initialState });
    dispatch(getHomePageById({ id, isDefaultHomePage: isDefaultHomePage }))
      .unwrap()
      .then((res) => {
        if (!res?.data) return;
        const data = res?.data;
        setStateName(data?.stateName);

        // ⭐ Add UUID to banners (safe)
        const bannersWithIds = (data.heroSection?.banners || []).map((b) => ({
          ...b,
          bannerId: crypto.randomUUID(),
        }));

        // ⭐ Fix menusItems mapping (handle overView separately)
        const menusItemsWithIds = Object.fromEntries(
          Object.entries(data.footerSection?.menusItems || {}).map(([key, menu]) => {
            const { subData, ...restMenu } = menu;

            // ⭐ CASE 1: overView → subData is OBJECT
            if (key === "overView") {
              return [
                key,
                {
                  ...restMenu,
                  subData: {
                    cta1: {
                      label: subData?.cta1?.label || "",
                      url: subData?.cta1?.url || "",
                    },
                    cta2: {
                      label: subData?.cta2?.label || "",
                      url: subData?.cta2?.url || "",
                    },
                    description: subData?.description || "",
                  },
                },
              ];
            }

            // ⭐ CASE 2: other menus → subData is ARRAY
            return [
              key,
              {
                ...restMenu,
                subData: (subData || []).map((item) => ({
                  ...item,
                  itemId: crypto.randomUUID(),
                })),
              },
            ];
          })
        );

        // ⭐ Final formData initialization
        setFormData({
          ...data,
          heroSection: {
            ...data.heroSection,
            banners: bannersWithIds,
          },
          footerSection: {
            ...data.footerSection,
            menusItems: menusItemsWithIds,
          },
        });

        // console.log("FORM DATA INITIALIZED:", data);
      })
      .catch((err) => {
        console.error("Error fetching Home Page:", err);
      });
  }, [id]);

  const initialState = {
    title: "",
    status: "published",
    stateName: "",
    stateCode: "",
    metaTitle: "",
    metaDescription: "",

    //********************************** hero Section ***************
    heroSection: {
      title: "",
      banners: [],
    },
    // ********************************** category Section ***************
    categorySection: [
      {
        categoryName: "",
        bentoGridHeading: "",
        layoutType: "No Grid",
        defaultRedirectUrlEnable: false,
        defaultGridUrl: "",
        desktopBanner: {
          imageUrl: "",
          title: "",
          description: "",
          altText: "",
          redirectUrl: "",
        },
        mobileBanner: {
          imageUrl: "",
          title: "",
          description: "",
          altText: "",
          redirectUrl: "",
        },
        desktopGrid: [],
        mobileGrid: [],
        arrayIndex: 0,
      },
    ],

    // ********************************* customer Review to review ****************

    customerReviews: "",

    //    ************** Favorite Delivery *********************

    deliverySection: {
      sectionTitle: "",
      sectionPara: "",
      subData: [
        {
          image: null,
          heading: "",
          subHeading: "",
          paragraph: "",
        },
      ],
    },

    // *************************** faq section to review *************************
    faqSection: {
      title: "",
      subData: [
        {
          question: "",
          answer: "",
        },
      ],
    },
    // ************************** footer section to review *********************
    footerSection: {
      paragraph: "",
      locationList: [
        // {
        //   locationName: "",
        //   locationLink: "",
        // },
      ],
      menusItems: {
        overView: {
          name: "Overview",
          title: "Overview test",
          subData: {
            cta1: {
              label: "",
              url: "",
            },
            cta2: {
              label: "",
              url: "",
            },
            description: "",
          },
        },
        siteMap: {
          name: "Site Map",
          title: "Sitemap test",
          subData: [
            // { label: "Home", url: "/", icon: "" }
          ],
        },
        traits: {
          name: "Traits",
          title: "Traits test",
          subData: [
            // { label: "Home", url: "/", icon: "" }
          ],
        },
        findYourCareer: {
          name: "Find Your Career",
          title: "Career test",
          subData: [
            // { label: "Home", url: "/", icon: "" }
          ],
        },
        quickLinks: {
          name: "Quick Links",
          title: "quickLinks test",
          subData: [
            // { label: "Home", url: "/", icon: "" }
          ],
        },
      },
    },
    createdBy: "",
  };

  const [formData, setFormData] = useState({
    ...initialState,
    createdBy: parseUser?.name,
    stateName: stateName,
    stateCode: matchedState?.stateCode || "",
    title: `${stateName} Home Page`,
  });

  useEffect(() => {
    if (mainGridApiRef?.current) {
      if (loading) {
        mainGridApiRef.current.showLoadingOverlay();
      } else if (banners?.total === 0) {
        mainGridApiRef.current.showNoRowsOverlay();
      } else {
        mainGridApiRef.current.hideOverlay();
      }
    }
  }, [banners, loading]);
  useEffect(() => {
    if (!mainGridApiRef.current) return;

    const ds = { getRows };
    mainGridApiRef.current.setDatasource(ds);
    mainGridApiRef.current.refreshInfiniteCache();
  }, [formData.heroSection.banners]);

  const columnDefs = [
    {
      headerName: "Desktop Image/Video",
      field: "desktop_image",
      suppressMenu: false,
      flex: 1.25,
      sortable: false,
      minWidth: 160,
      cellRenderer: (props) => {
        const { data: item } = props;
        if (!item?.desktop_image) return null;
        return item?.mediaType === "video" ? (
          <Zoom key={item.desktop_image} classDialog="custom-zoom">
            <video style={thumbnail} loop autoPlay playsInline muted>
              <source
                key={item.desktop_image}
                src={item.desktop_image}
                style={{ borderRadius: "10px" }}
                type="video/mp4"
              />
            </video>
          </Zoom>
        ) : (
          <Zoom key={item.desktop_image} classDialog="custom-zoom">
            <img src={item.desktop_image} style={thumbnail} />
          </Zoom>
        );
      },
    },
    {
      headerName: "Mobile Image/Video",
      field: "mobile_image",
      suppressMenu: false,
      flex: 1.25,
      sortable: false,
      minWidth: 160,
      cellRenderer: (props) => {
        const { data: item } = props;
        if (!item?.mediaType) return null;
        return item?.mediaType === "video" ? (
          <Zoom key={item.desktop_image} classDialog="custom-zoom">
            <video style={thumbnail} loop autoPlay playsInline muted>
              <source
                key={item.mobile_image}
                src={item.mobile_image}
                style={{ borderRadius: "10px" }}
                type="video/mp4"
              />
            </video>
          </Zoom>
        ) : (
          <Zoom key={item.mobile_image} classDialog="custom-zoom">
            <img src={item.mobile_image} style={thumbnail} />
          </Zoom>
        );
      },
    },
    {
      headerName: "Destination URL",
      field: "url",
      flex: 1.75,
      sortable: false,
      minWidth: 220,
      suppressMenu: false,
      cellRenderer: (props) => {
        return props?.value ? (
          <Link target="_blank" style={linkStyle} to={props?.value}>
            {props?.value}
            <OpenInNewSharp />
          </Link>
        ) : (
          "-"
        );
      },
    },
    {
      headerName: "Mobile Description",
      field: "mobile_description",
      flex: 2,
      sortable: false,
      suppressMenu: true,
      wrapText: true,
      minWidth: 280,
      cellRenderer: (props) => {
        return props?.value ? (
          <Tooltip title={capitalizeText(props?.value)} arrow placement="top">
            <MDBox textAlign="left">
              <Typography
                variant="p"
                // color="dark"
                lineHeight={1.25}
                // fontWeight="semibold"
                className="text-14 truncate line-1"
              >
                {capitalizeText(props?.value)}
              </Typography>
            </MDBox>
          </Tooltip>
        ) : (
          "-"
        );
      },
    },
    {
      headerName: "Desktop Description",
      field: "desktop_description",
      flex: 2,
      sortable: false,
      suppressMenu: true,
      wrapText: true,
      minWidth: 280,
      cellRenderer: (props) => {
        return props?.value ? (
          <Tooltip title={capitalizeText(props?.value)} arrow placement="top">
            <MDBox textAlign="left">
              <Typography
                variant="p"
                color="dark"
                lineHeight={1.25}
                // fontWeight="semibold"
                className="text-14 truncate line-1"
              >
                {capitalizeText(props?.value)}
              </Typography>
            </MDBox>
          </Tooltip>
        ) : (
          "-"
        );
      },
    },
    {
      headerName: "Status",
      field: "status",
      flex: 1,
      // sortable: false,
      minWidth: 100,
      suppressMenu: false,
      cellRenderer: (props) => {
        const status = props.value?.toLowerCase();

        const isActive = status === "active";

        return (
          <Box
            display="flex"
            alignItems="center"
            className="status-col"
            color={isActive ? "#24CA49" : "#FF4D4D"} // red for inactive
          >
            {isActive ? (
              <ActiveIcon width="18px" height="18px" flex="none" />
            ) : (
              <InActiveIcon width="18px" height="18px" flex="none" />
            )}

            <Typography variant="caption" fontWeight="regular" ml={0.5} textTransform="capitalize">
              {props.value}
            </Typography>
          </Box>
        );
      },
    },
    {
      headerName: "Media Type",
      field: "mediaType",
      flex: 1,
      // sortable: false,
      minWidth: 120,
      suppressMenu: false,
      cellRenderer: (props) => {
        return props?.value ? props.value : "-";
      },
      cellStyle: { textAlign: "right", justifyContent: "end" },
      headerClass: "right-aligned-cell-header",
      // pinned: "right",
    },
  ];
  const handleCopyLink = (Link) => {
    navigator.clipboard
      .writeText(Link)
      .then(() => {
        setCopyStatus("Copied!");
        setTimeout(() => setCopyStatus(""), 1000); // Clear message after 2 seconds
      })
      .catch(() => {
        setCopyStatus("Failed to copy");
        setTimeout(() => setCopyStatus(""), 1000); // Clear message after 2 seconds
      });
  };
  function getSortInfo(data) {
    if (!data || data.length === 0) {
      return null;
    }
    const sortModel = data[0];
    return {
      sortField: sortModel.colId,
      sortOrder: sortModel.sort,
    };
  }

  const getRows = async (params) => {
    gridRefApi.current = params;

    let sortInfo = null;
    if (params?.sortModel?.length) {
      sortInfo = getSortInfo(params.sortModel);
    }

    if (formData?.heroSection?.banners?.length > 0) {
      let rowData = formData.heroSection.banners.map((item) => ({
        ...item,
        desktop_image: item.desktop.imageFile || "",
        mobile_image: item.mobile.imageFile || "",
        url: item.destinationUrl || "",
        desktop_description: item.desktop.description || "",
        mobile_description: item.mobile.description || "",
        status: item.status === "active" ? "active" : "inactive",
        media_type: ["mp4", "webm"].includes(
          (item?.desktopImage?.split(".").pop() || "").toLowerCase()
        )
          ? "video"
          : "image",
        bannerId: item.bannerId,
      }));

      if (sortInfo) {
        rowData = sortLocalData(rowData, sortInfo);
      }

      return params.successCallback(rowData, rowData.length);
    }
  };

  const sortLocalData = (data, sortInfo) => {
    const { sortField, sortOrder } = sortInfo;

    return [...data].sort((a, b) => {
      let aValue = a[sortField];
      let bValue = b[sortField];

      if (typeof aValue === "string") {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }

      if (sortOrder === "asc") {
        if (aValue < bValue) return -1;
        if (aValue > bValue) return 1;
        return 0;
      } else {
        if (aValue > bValue) return -1;
        if (aValue < bValue) return 1;
        return 0;
      }
    });
  };
  function formatStateName(state) {
    if (!state) return "";
    return state
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
  const quillToPlainText = (html = "") => {
    const temp = document.createElement("div");
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || "";
  };
  // console.log(isDefaultHomePage, "thisisdefaulttttt");

  return (
    <CommonLayout>
      {getLoading ? (
        <Loader />
      ) : (
        <Grid item xs={12} sm={4} md={2} xxl={2} className="static-pages-container">
          <Box p={{ xs: 2, sm: 3, lg: 4 }} style={{ paddingBottom: 0 }}>
            {isDefaultHomePage ? (
              ""
            ) : (
              <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                <Box display="flex" alignItems="center" color="text.main" lineHeight={1}>
                  <span
                    style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    <AngleRightIcon fontSize="14px" />
                    <Typography variant="h6" fontWeight="semibold" ml={0.75}>
                      State Page
                    </Typography>
                  </span>
                </Box>
              </Box>
            )}

            {/********************** Page Title **********************/}
            <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: "none" }}>
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Typography
                  variant="h4"
                  color="#2E2E3A"
                  fontWeight="700"
                  style={{ fontSize: "20px" }}
                >
                  {isDefaultHomePage ? "Home Page" : `State Page for ${stateName}`}
                </Typography>
                <Box
                  display="flex"
                  sx={{ cursor: "pointer" }}
                  alignItems="center"
                  color="text.main"
                  lineHeight={1}
                  gap={2}
                  style={{ position: "relative" }}
                >
                  {id && formData?.canonical && (
                    <>
                      <Tooltip title={copyStatus ? copyStatus : "Copy"} arrow>
                        <IconButton
                          onClick={() => handleCopyLink(formData?.canonical)}
                          size="small"
                          sx={{ color: "primary.main" }}
                        >
                          <ContentCopyIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Typography
                        variant="body"
                        component="a"
                        href={formData?.canonical}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ textDecoration: "none", color: "inherit" }}
                        style={{
                          borderRadius: "26px",
                          color: "#0163FF",
                          fontSize: "14px",
                          fontWeight: "600",
                          border: "1px solid #0163FF",
                          padding: "10px 16px",
                        }}
                        // onClick={(event) => event.preventDefault()}
                      >
                        {formData?.canonical}
                      </Typography>
                    </>
                  )}
                  {isDefaultHomePage && (
                    <>
                      <Tooltip title={copyStatus ? copyStatus : "Copy"} arrow>
                        <IconButton
                          onClick={() => handleCopyLink("https://hyperwolf.com/shop")}
                          size="small"
                          sx={{ color: "primary.main" }}
                        >
                          <ContentCopyIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Typography
                        variant="body"
                        component="a"
                        href={formData?.canonical}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ textDecoration: "none", color: "inherit" }}
                        style={{
                          borderRadius: "26px",
                          color: "#0163FF",
                          fontSize: "14px",
                          fontWeight: "600",
                          border: "1px solid #0163FF",
                          padding: "10px 16px",
                        }}
                        // onClick={(event) => event.preventDefault()}
                      >
                        {"https://hyperwolf.com/shop"}
                      </Typography>
                    </>
                  )}
                  <MDButton
                    sx={{ gap: "12px", minWidth: "130px" }}
                    type="button"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      if (isDefaultHomePage) {
                        navigate(`/defaultHomepage/edit`);
                        return;
                      }
                      navigate(`/homepage/edit/${id}`);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_26193_49746)">
                        <path
                          d="M9.64576 2.83594L1.94276 10.5395C1.904 10.5784 1.87602 10.6274 1.8627 10.6802L1.00889 14.1072C0.983354 14.2103 1.01367 14.32 1.08895 14.3953C1.14592 14.4523 1.22354 14.4838 1.30293 14.4838C1.32725 14.4838 1.35212 14.4808 1.37633 14.4747L4.80332 13.6208C4.85673 13.6075 4.90525 13.5796 4.94401 13.5409L12.6477 5.83785L9.64576 2.83594Z"
                          fill="white"
                        />
                        <path
                          d="M14.5561 1.78708L13.6986 0.929609C13.1255 0.35652 12.1267 0.357075 11.5543 0.929609L10.5039 1.97996L13.5057 4.98176L14.5561 3.93141C14.8423 3.64526 15 3.26438 15 2.8593C15 2.45422 14.8423 2.07334 14.5561 1.78708Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_26193_49746">
                          <rect width="15" height="15" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span>Edit</span>
                  </MDButton>
                </Box>
              </Box>
            </Card>

            {/********************** Meta Tags **********************/}
            <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: "none" }}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                spacing={3}
                mb={4}
              >
                <Typography variant="h5" fontWeight="semibold">
                  Meta Properties
                </Typography>
              </Stack>

              <Grid container alignItems="center" spacing={3} mb={2}>
                <Grid item xs={12}>
                  <Typography variant="body2" color="#656575" mb={1} style={{ fontSize: "14px" }}>
                    Meta Title
                  </Typography>
                  <Typography variant="h5" fontWeight="medium">
                    {formData?.metaTitle ? formData?.metaTitle : "-"}
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="body2" color="#656575" mb={1} style={{ fontSize: "14px" }}>
                    Description
                  </Typography>
                  <Typography variant="h5" fontWeight="medium">
                    {formData?.metaDescription ? formData?.metaDescription : "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Card>

            {/********************** Hero Section **********************/}
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panelhero-content"
                id="panelhero-header"
              >
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography variant="h4" fontWeight="semibold" style={{ color: "#2E2E3A" }}>
                    Hero Section
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container direction="row" spacing={3}>
                  <Grid item xs={12} md={12}>
                    <Typography variant="body2" color="#656575" mb={1} style={{ fontSize: "14px" }}>
                      Heading (H1)
                    </Typography>
                    <Typography variant="h5" fontWeight="medium">
                      {formData?.heroSection?.title ? formData?.heroSection?.title : "-"}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Typography variant="body2" color="#656575" mb={1} style={{ fontSize: "14px" }}>
                      Paragraph (P)
                    </Typography>
                    <Typography variant="h5" fontWeight="medium">
                      {/* {quillToPlainText(formData?.heroSection?.heroSectionPara)} */}
                      <Grid container direction="row" spacing={3}>
                        {!formData?.heroSection?.heroSectionPara ? (
                          <Grid item xs={12} md={12}>
                            <Typography variant="h5" fontWeight="medium">
                              -
                            </Typography>
                          </Grid>
                        ) : (
                          <Grid item xs={12} md={12}>
                            <div
                              style={{ maxHeight: "400px", overflow: "auto" }}
                              dangerouslySetInnerHTML={{
                                __html: formData?.heroSection?.heroSectionPara,
                              }}
                            ></div>
                          </Grid>
                        )}
                      </Grid>
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Typography variant="body2" color="#656575" mb={2} style={{ fontSize: "14px" }}>
                      Banners
                    </Typography>
                    {!formData?.heroSection?.banners?.length > 0 ? (
                      <NoDataFound />
                    ) : (
                      <AgGridTable
                        col={columnDefs}
                        getRows={getRows}
                        mainGridApiRef={mainGridApiRef}
                        pageRef={pageRef}
                        isLoading={loading}
                        style={{ height: "340px" }}
                        gridOptions={{
                          rowHeight: 100,
                        }}
                      />
                    )}
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            {/********************** Category Section **********************/}
            <Accordion className="view-categories-sec">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panelcategory-content"
                id="panelcategory-header"
              >
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography variant="h4" fontWeight="semibold" style={{ color: "#2E2E3A" }}>
                    Category Section
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                {Array.isArray(formData?.categorySection) &&
                  formData.categorySection.length === 0 && (
                    <Box
                      sx={{
                        mt: 8,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        width: "100%",
                      }}
                    >
                      <NoDataFound />
                    </Box>
                  )}
                {Array.isArray(formData?.categorySection) &&
                  formData.categorySection.map((category, idx) => {
                    // console.log("categorysssssssssssss:", category);
                    switch (category.layoutType) {
                      case "Two Column-Left":
                        return (
                          <Card
                            key={`category-two-column-left-${idx}`}
                            sx={{
                              p: { xs: 2, md: 3 },
                              borderRadius: 2.5,
                              boxShadow: "none",
                              backgroundColor: "#F5F5FF",
                              marginBottom: "15px",
                              position: "relative",
                            }}
                            className="repeat-card"
                          >
                            <Accordion>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panelcategory-01-content"
                                id="panelcategory-01-header"
                              >
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Typography
                                    variant="h4"
                                    fontWeight="semibold"
                                    style={{ color: "#2E2E3A" }}
                                  >
                                    {category?.categoryName}
                                  </Typography>
                                </Box>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid container direction="row" spacing={3} mt={0}>
                                  <Grid item xs={12} style={{ paddingTop: "10px" }}>
                                    <Box>
                                      <Typography
                                        variant="body2"
                                        color="#656575"
                                        mb={1}
                                        style={{ fontSize: "14px" }}
                                      >
                                        Bento Grid Heading (H2)
                                      </Typography>
                                      <Typography variant="h5" fontWeight="medium">
                                        {category?.bentoGridHeading}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Grid container direction="row" spacing={3} mt={0}>
                                      <Grid item xs={12} md={6}>
                                        <div className="bento-container">
                                          <Box mb={3}>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Grid for Desktop
                                            </Typography>
                                            <div className="bento-img-container bento-small-large two-column-left">
                                              <Zoom
                                                key={
                                                  category?.desktopGrid[0]?.imageUrl || defaultImage
                                                }
                                                classDialog="custom-zoom"
                                                style={{ width: "100%" }}
                                              >
                                                <img
                                                  src={
                                                    category?.desktopGrid[0]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.desktopGrid[0]?.altText || ""}
                                                />
                                              </Zoom>
                                              <div className="img-bento">
                                                <Zoom
                                                  key={
                                                    category?.desktopGrid[1]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  style={{ width: "100%" }}
                                                  classDialog="custom-zoom"
                                                >
                                                  <img
                                                    src={
                                                      category?.desktopGrid[1]?.imageUrl ||
                                                      defaultImage
                                                    }
                                                    alt={category?.desktopGrid[1]?.altText || ""}
                                                  />
                                                </Zoom>
                                                <Zoom
                                                  key={
                                                    category?.desktopGrid[2]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  style={{ width: "100%" }}
                                                  classDialog="custom-zoom"
                                                >
                                                  <img
                                                    src={
                                                      category?.desktopGrid[2]?.imageUrl ||
                                                      defaultImage
                                                    }
                                                    alt={category?.desktopGrid[2]?.altText || ""}
                                                  />
                                                </Zoom>
                                              </div>
                                            </div>
                                          </Box>
                                          <Box>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Category Banner For Desktop
                                            </Typography>
                                            <Box
                                              // onClick={() => {
                                              //   if (category?.defaultRedirectUrlEnable) {
                                              //     window.open(category?.defaultGridUrl, "_blank");
                                              //   } else {
                                              //     if (category?.desktopBanner?.redirectUrl) {
                                              //       window.open(
                                              //         category.desktopBanner.redirectUrl,
                                              //         "_blank"
                                              //       );
                                              //     }
                                              //   }
                                              // }}
                                              style={{
                                                width: "100%",
                                                display: "flex",
                                                borderRadius: "20px",
                                                overflow: "hidden",
                                                height: "170px",
                                              }}
                                            >
                                              <Zoom
                                                key={
                                                  category?.desktopBanner?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                  }}
                                                  src={
                                                    category?.desktopBanner?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.desktopBanner?.altText || ""}
                                                />
                                              </Zoom>
                                            </Box>
                                          </Box>
                                        </div>
                                      </Grid>
                                      <Grid item xs={12} md={6}>
                                        <div className="bento-container">
                                          <Box mb={3}>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Grid for Mobile
                                            </Typography>
                                            <div className="bento-img-container bento-small-large two-column-left">
                                              <Zoom
                                                key={
                                                  category?.mobileGrid[0]?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  src={
                                                    category?.mobileGrid[0]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.mobileGrid[0]?.altText || ""}
                                                />
                                              </Zoom>
                                              <div className="img-bento">
                                                <Zoom
                                                  key={
                                                    category?.mobileGrid[1]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  style={{ width: "100%" }}
                                                  classDialog="custom-zoom"
                                                >
                                                  <img
                                                    src={
                                                      category?.mobileGrid[1]?.imageUrl ||
                                                      defaultImage
                                                    }
                                                    alt={category?.mobileGrid[1]?.altText || ""}
                                                  />
                                                </Zoom>
                                                <Zoom
                                                  key={
                                                    category?.mobileGrid[2]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  style={{ width: "100%" }}
                                                  classDialog="custom-zoom"
                                                >
                                                  <img
                                                    src={
                                                      category?.mobileGrid[2]?.imageUrl ||
                                                      defaultImage
                                                    }
                                                    alt={category?.mobileGrid[2]?.altText || ""}
                                                  />
                                                </Zoom>
                                              </div>
                                            </div>
                                          </Box>
                                          <Box>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Category Banner For Mobile
                                            </Typography>
                                            <Box
                                              // onClick={() => {
                                              //   if (category?.defaultRedirectUrlEnable) {
                                              //     window.open(category?.defaultGridUrl, "_blank");
                                              //   } else {
                                              //     if (category?.mobileBanner?.redirectUrl) {
                                              //       window.open(
                                              //         category.mobileBanner.redirectUrl,
                                              //         "_blank"
                                              //       );
                                              //     }
                                              //   }
                                              // }}
                                              style={{
                                                width: "100%",
                                                display: "flex",
                                                borderRadius: "20px",
                                                overflow: "hidden",
                                                height: "170px",
                                              }}
                                            >
                                              <Zoom
                                                key={
                                                  category?.mobileBanner?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                  }}
                                                  src={
                                                    category?.mobileBanner?.imageUrl || defaultImage
                                                  }
                                                  alt={category?.mobileBanner?.altText || ""}
                                                />
                                              </Zoom>
                                            </Box>
                                          </Box>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Card>
                        );
                      case "Two Column-Right":
                        return (
                          <Card
                            sx={{
                              p: { xs: 2, md: 3 },
                              borderRadius: 2.5,
                              boxShadow: "none",
                              backgroundColor: "#F5F5FF",
                              marginBottom: "15px",
                              position: "relative",
                            }}
                            className="repeat-card"
                          >
                            <Accordion>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panelcategory-02-content"
                                id="panelcategory-02-header"
                              >
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Typography
                                    variant="h4"
                                    fontWeight="semibold"
                                    style={{ color: "#2E2E3A" }}
                                  >
                                    {category?.categoryName}
                                  </Typography>
                                </Box>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid container direction="row" spacing={3} mt={0}>
                                  <Grid item xs={12} style={{ paddingTop: "10px" }}>
                                    <Box>
                                      <Typography
                                        variant="body2"
                                        color="#656575"
                                        mb={1}
                                        style={{ fontSize: "14px" }}
                                      >
                                        Bento Grid Heading (H2)
                                      </Typography>
                                      <Typography variant="h5" fontWeight="medium">
                                        {category?.bentoGridHeading}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Grid container direction="row" spacing={3} mt={0}>
                                      <Grid item xs={12} md={6}>
                                        <div className="bento-container">
                                          <Box mb={3}>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Grid for Desktop
                                            </Typography>
                                            <div className="bento-img-container bento-small-large two-column-right">
                                              <div className="img-bento">
                                                <Zoom
                                                  key={
                                                    category?.desktopGrid[0]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  style={{ width: "100%" }}
                                                  classDialog="custom-zoom"
                                                >
                                                  <img
                                                    src={
                                                      category?.desktopGrid[0]?.imageUrl ||
                                                      defaultImage
                                                    }
                                                    alt={category?.desktopGrid[0]?.altText || ""}
                                                  />
                                                </Zoom>
                                                <Zoom
                                                  key={
                                                    category?.desktopGrid[0]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  style={{ width: "100%" }}
                                                  classDialog="custom-zoom"
                                                >
                                                  <img
                                                    src={
                                                      category?.desktopGrid[0]?.imageUrl ||
                                                      defaultImage
                                                    }
                                                    alt={category?.desktopGrid[1]?.altText || ""}
                                                  />
                                                </Zoom>
                                              </div>
                                              <Zoom
                                                key={
                                                  category?.desktopGrid[2]?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  src={
                                                    category?.desktopGrid[2]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.desktopGrid[2]?.altText || ""}
                                                />
                                              </Zoom>
                                            </div>
                                          </Box>
                                          <Box>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Category Banner For Desktop
                                            </Typography>
                                            <Box
                                              // onClick={() => {
                                              //   if (category?.defaultRedirectUrlEnable) {
                                              //     window.open(category?.defaultGridUrl, "_blank");
                                              //   } else {
                                              //     if (category?.desktopBanner?.redirectUrl) {
                                              //       window.open(
                                              //         category.desktopBanner.redirectUrl,
                                              //         "_blank"
                                              //       );
                                              //     }
                                              //   }
                                              // }}
                                              style={{
                                                width: "100%",
                                                display: "flex",
                                                borderRadius: "20px",
                                                overflow: "hidden",
                                                height: "170px",
                                              }}
                                            >
                                              <Zoom
                                                key={
                                                  category?.desktopBanner?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                  }}
                                                  src={
                                                    category?.desktopBanner?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.desktopBanner?.altText || ""}
                                                />
                                              </Zoom>
                                            </Box>
                                          </Box>
                                        </div>
                                      </Grid>
                                      <Grid item xs={12} md={6}>
                                        <div className="bento-container">
                                          <Box mb={3}>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Grid for Mobile
                                            </Typography>
                                            <div className="bento-img-container bento-small-large two-column-right">
                                              <div className="img-bento">
                                                <Zoom
                                                  key={
                                                    category?.mobileGrid[0]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  style={{ width: "100%" }}
                                                  classDialog="custom-zoom"
                                                >
                                                  <img
                                                    src={
                                                      category?.mobileGrid[0]?.imageUrl ||
                                                      defaultImage
                                                    }
                                                    alt={category?.mobileGrid[0]?.altText || ""}
                                                  />
                                                </Zoom>
                                                <Zoom
                                                  key={
                                                    category?.mobileGrid[1]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  style={{ width: "100%" }}
                                                  classDialog="custom-zoom"
                                                >
                                                  <img
                                                    src={
                                                      category?.mobileGrid[1]?.imageUrl ||
                                                      defaultImage
                                                    }
                                                    alt={category?.mobileGrid[1]?.altText || ""}
                                                  />
                                                </Zoom>
                                              </div>
                                              <Zoom
                                                key={
                                                  category?.mobileGrid[2]?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  src={
                                                    category?.mobileGrid[2]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.mobileGrid[2]?.altText || ""}
                                                />
                                              </Zoom>
                                            </div>
                                          </Box>
                                          <Box>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Category Banner For Mobile
                                            </Typography>
                                            <Box
                                              // onClick={() => {
                                              //   if (category?.defaultRedirectUrlEnable) {
                                              //     window.open(category?.defaultGridUrl, "_blank");
                                              //   } else {
                                              //     if (category?.mobileBanner?.redirectUrl) {
                                              //       window.open(
                                              //         category.mobileBanner.redirectUrl,
                                              //         "_blank"
                                              //       );
                                              //     }
                                              //   }
                                              // }}
                                              style={{
                                                width: "100%",
                                                display: "flex",
                                                borderRadius: "20px",
                                                overflow: "hidden",
                                                height: "170px",
                                              }}
                                            >
                                              <Zoom
                                                key={
                                                  category?.mobileBanner?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                  }}
                                                  src={
                                                    category?.mobileBanner?.imageUrl || defaultImage
                                                  }
                                                  alt={category?.mobileBanner?.altText || ""}
                                                />
                                              </Zoom>
                                            </Box>
                                          </Box>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Card>
                        );
                      case "Full Width":
                        return (
                          <Card
                            key={`category-full-width-${idx}`}
                            sx={{
                              p: { xs: 2, md: 3 },
                              borderRadius: 2.5,
                              boxShadow: "none",
                              backgroundColor: "#F5F5FF",
                              marginBottom: "15px",
                              position: "relative",
                            }}
                            className="repeat-card"
                          >
                            <Accordion>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panelcategory-03-content-${idx}`}
                                id={`panelcategory-03-header-${idx}`}
                              >
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Typography
                                    variant="h4"
                                    fontWeight="semibold"
                                    style={{ color: "#2E2E3A" }}
                                  >
                                    {category?.categoryName}
                                  </Typography>
                                </Box>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid container direction="row" spacing={3} mt={0}>
                                  <Grid item xs={12} style={{ paddingTop: "10px" }}>
                                    <Box>
                                      <Typography
                                        variant="body2"
                                        color="#656575"
                                        mb={1}
                                        style={{ fontSize: "14px" }}
                                      >
                                        Bento Grid Heading (H2)
                                      </Typography>
                                      <Typography variant="h5" fontWeight="medium">
                                        {category?.bentoGridHeading}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Grid container direction="row" spacing={3} mt={0}>
                                      <Grid item xs={12} md={6}>
                                        <div className="bento-container">
                                          <Box mb={3}>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Grid for Desktop
                                            </Typography>
                                            <div className="image-section large-img">
                                              <Zoom
                                                key={
                                                  category?.desktopGrid[0]?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  src={
                                                    category?.desktopGrid[0]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.desktopGrid[0]?.altText || ""}
                                                />
                                              </Zoom>
                                            </div>
                                          </Box>
                                          <Box>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Category Banner For Desktop
                                            </Typography>
                                            <Box
                                              // onClick={() => {
                                              //   if (category?.defaultRedirectUrlEnable) {
                                              //     window.open(category?.defaultGridUrl, "_blank");
                                              //   } else {
                                              //     if (category?.desktopBanner?.redirectUrl) {
                                              //       window.open(
                                              //         category.desktopBanner.redirectUrl,
                                              //         "_blank"
                                              //       );
                                              //     }
                                              //   }
                                              // }}
                                              style={{
                                                width: "100%",
                                                display: "flex",
                                                borderRadius: "20px",
                                                overflow: "hidden",
                                                height: "170px",
                                              }}
                                            >
                                              <Zoom
                                                key={
                                                  category?.desktopBanner?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                  }}
                                                  src={
                                                    category?.desktopBanner?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.desktopBanner?.altText || ""}
                                                />
                                              </Zoom>
                                            </Box>
                                          </Box>
                                        </div>
                                      </Grid>
                                      <Grid item xs={12} md={6}>
                                        <div className="bento-container">
                                          <Box mb={3}>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Grid for Mobile
                                            </Typography>
                                            <div className="image-section large-img">
                                              <Zoom
                                                key={
                                                  category?.mobileGrid[0]?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  src={
                                                    category?.mobileGrid[0]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.mobileGrid[0]?.altText || ""}
                                                />
                                              </Zoom>
                                            </div>
                                          </Box>
                                          <Box>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Category Banner For Mobile
                                            </Typography>
                                            <Box
                                              // onClick={() => {
                                              //   if (category?.defaultRedirectUrlEnable) {
                                              //     window.open(category?.defaultGridUrl, "_blank");
                                              //   } else {
                                              //     if (category?.mobileBanner?.redirectUrl) {
                                              //       window.open(
                                              //         category.mobileBanner.redirectUrl,
                                              //         "_blank"
                                              //       );
                                              //     }
                                              //   }
                                              // }}
                                              style={{
                                                width: "100%",
                                                display: "flex",
                                                borderRadius: "20px",
                                                overflow: "hidden",
                                                height: "170px",
                                              }}
                                            >
                                              <Zoom
                                                key={
                                                  category?.mobileBanner?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                  }}
                                                  src={
                                                    category?.mobileBanner?.imageUrl || defaultImage
                                                  }
                                                  alt={category?.mobileBanner?.altText || ""}
                                                />
                                              </Zoom>
                                            </Box>
                                          </Box>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Card>
                        );
                      case "Stacked Grid":
                        return (
                          <Card
                            sx={{
                              p: { xs: 2, md: 3 },
                              borderRadius: 2.5,
                              boxShadow: "none",
                              backgroundColor: "#F5F5FF",
                              marginBottom: "15px",
                              position: "relative",
                            }}
                            className="repeat-card"
                          >
                            <Accordion>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panelcategory-04-content"
                                id="panelcategory-04-header"
                              >
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Typography
                                    variant="h4"
                                    fontWeight="semibold"
                                    style={{ color: "#2E2E3A" }}
                                  >
                                    {category?.categoryName}
                                  </Typography>
                                </Box>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid container direction="row" spacing={3} mt={0}>
                                  <Grid item xs={12} style={{ paddingTop: "10px" }}>
                                    <Box>
                                      <Typography
                                        variant="body2"
                                        color="#656575"
                                        mb={1}
                                        style={{ fontSize: "14px" }}
                                      >
                                        Bento Grid Heading (H2)
                                      </Typography>
                                      <Typography variant="h5" fontWeight="medium">
                                        {category?.bentoGridHeading}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Grid container direction="row" spacing={3} mt={0}>
                                      <Grid item xs={12} md={6}>
                                        <div className="bento-container">
                                          <Box mb={3}>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Grid for Desktop
                                            </Typography>
                                            <div className="img-bento">
                                              <div className="img-bento-row">
                                                <Zoom
                                                  key={
                                                    category?.desktopGrid[0]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  style={{ width: "100%" }}
                                                  classDialog="custom-zoom"
                                                >
                                                  <img
                                                    src={
                                                      category?.desktopGrid[0]?.imageUrl ||
                                                      defaultImage
                                                    }
                                                    alt={category?.desktopGrid[0]?.altText || ""}
                                                  />
                                                </Zoom>
                                              </div>
                                              <div className="img-bento-row img-bento-two-row">
                                                <Zoom
                                                  key={
                                                    category?.desktopGrid[1]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  style={{ width: "100%" }}
                                                  classDialog="custom-zoom"
                                                >
                                                  <img
                                                    src={
                                                      category?.desktopGrid[1]?.imageUrl ||
                                                      defaultImage
                                                    }
                                                    alt={category?.desktopGrid[1]?.altText || ""}
                                                  />
                                                </Zoom>
                                                <Zoom
                                                  key={
                                                    category?.desktopGrid[2]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  style={{ width: "100%" }}
                                                  classDialog="custom-zoom"
                                                >
                                                  <img
                                                    src={
                                                      category?.desktopGrid[2]?.imageUrl ||
                                                      defaultImage
                                                    }
                                                    alt={category?.desktopGrid[2]?.altText || ""}
                                                  />
                                                </Zoom>
                                              </div>
                                            </div>
                                          </Box>
                                          <Box>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Category Banner For Desktop
                                            </Typography>
                                            <Box
                                              // onClick={() => {
                                              //   if (category?.defaultRedirectUrlEnable) {
                                              //     window.open(category?.defaultGridUrl, "_blank");
                                              //   } else {
                                              //     if (category?.desktopBanner?.redirectUrl) {
                                              //       window.open(
                                              //         category.desktopBanner.redirectUrl,
                                              //         "_blank"
                                              //       );
                                              //     }
                                              //   }
                                              // }}
                                              style={{
                                                width: "100%",
                                                display: "flex",
                                                borderRadius: "20px",
                                                overflow: "hidden",
                                                height: "170px",
                                              }}
                                            >
                                              <Zoom
                                                key={
                                                  category?.desktopBanner?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                  }}
                                                  src={
                                                    category?.desktopBanner?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.desktopBanner?.altText || ""}
                                                />
                                              </Zoom>
                                            </Box>
                                          </Box>
                                        </div>
                                      </Grid>
                                      <Grid item xs={12} md={6}>
                                        <div className="bento-container">
                                          <Box mb={3}>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Grid for Mobile
                                            </Typography>
                                            <div className="img-bento">
                                              <div className="img-bento-row">
                                                <Zoom
                                                  key={
                                                    category?.mobileGrid[0]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  style={{ width: "100%" }}
                                                  classDialog="custom-zoom"
                                                >
                                                  <img
                                                    src={
                                                      category?.mobileGrid[0]?.imageUrl ||
                                                      defaultImage
                                                    }
                                                    alt={category?.mobileGrid[0]?.altText || ""}
                                                  />
                                                </Zoom>
                                              </div>
                                              <div className="img-bento-row img-bento-two-row">
                                                <Zoom
                                                  key={
                                                    category?.mobileGrid[1]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  style={{ width: "100%" }}
                                                  classDialog="custom-zoom"
                                                >
                                                  <img
                                                    src={
                                                      category?.mobileGrid[1]?.imageUrl ||
                                                      defaultImage
                                                    }
                                                    alt={category?.mobileGrid[1]?.altText || ""}
                                                  />
                                                </Zoom>
                                                <Zoom
                                                  key={
                                                    category?.mobileGrid[2]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  style={{ width: "100%" }}
                                                  classDialog="custom-zoom"
                                                >
                                                  <img
                                                    src={
                                                      category?.mobileGrid[2]?.imageUrl ||
                                                      defaultImage
                                                    }
                                                    alt={category?.mobileGrid[2]?.altText || ""}
                                                  />
                                                </Zoom>
                                              </div>
                                            </div>
                                          </Box>
                                          <Box>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Category Banner For Mobile
                                            </Typography>
                                            <Box
                                              // onClick={() => {
                                              //   if (category?.defaultRedirectUrlEnable) {
                                              //     window.open(category?.defaultGridUrl, "_blank");
                                              //   } else {
                                              //     if (category?.mobileBanner?.redirectUrl) {
                                              //       window.open(
                                              //         category.mobileBanner.redirectUrl,
                                              //         "_blank"
                                              //       );
                                              //     }
                                              //   }
                                              // }}
                                              style={{
                                                width: "100%",
                                                display: "flex",
                                                borderRadius: "20px",
                                                overflow: "hidden",
                                                height: "170px",
                                              }}
                                            >
                                              <Zoom
                                                key={
                                                  category?.mobileBanner?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                  }}
                                                  src={
                                                    category?.mobileBanner?.imageUrl || defaultImage
                                                  }
                                                  alt={category?.mobileBanner?.altText || ""}
                                                />
                                              </Zoom>
                                            </Box>
                                          </Box>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Card>
                        );
                      case "Two Column":
                        return (
                          <Card
                            sx={{
                              p: { xs: 2, md: 3 },
                              borderRadius: 2.5,
                              boxShadow: "none",
                              backgroundColor: "#F5F5FF",
                              marginBottom: "15px",
                              position: "relative",
                            }}
                            className="repeat-card"
                          >
                            <Accordion>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panelcategory-05-content"
                                id="panelcategory-05-header"
                              >
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Typography
                                    variant="h4"
                                    fontWeight="semibold"
                                    style={{ color: "#2E2E3A" }}
                                  >
                                    {category?.categoryName}
                                  </Typography>
                                </Box>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid container direction="row" spacing={3} mt={0}>
                                  <Grid item xs={12} style={{ paddingTop: "10px" }}>
                                    <Box>
                                      <Typography
                                        variant="body2"
                                        color="#656575"
                                        mb={1}
                                        style={{ fontSize: "14px" }}
                                      >
                                        Bento Grid Heading (H2)
                                      </Typography>
                                      <Typography variant="h5" fontWeight="medium">
                                        {category?.bentoGridHeading}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Grid container direction="row" spacing={3} mt={0}>
                                      <Grid item xs={12} md={6}>
                                        <div className="bento-container">
                                          <Box mb={3}>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Grid for Desktop
                                            </Typography>
                                            <div className="bento-img-container bento-large-small">
                                              <Zoom
                                                key={
                                                  category?.desktopGrid[0]?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  src={
                                                    category?.desktopGrid[0]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.desktopGrid[0]?.altText || ""}
                                                />
                                              </Zoom>
                                              <Zoom
                                                key={
                                                  category?.desktopGrid[1]?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  src={
                                                    category?.desktopGrid[1]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.desktopGrid[1]?.altText || ""}
                                                />
                                              </Zoom>
                                            </div>
                                          </Box>
                                          <Box>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Category Banner For Desktop
                                            </Typography>
                                            <Box
                                              // onClick={() => {
                                              //   if (category?.defaultRedirectUrlEnable) {
                                              //     window.open(category?.defaultGridUrl, "_blank");
                                              //   } else {
                                              //     if (category?.desktopBanner?.redirectUrl) {
                                              //       window.open(
                                              //         category.desktopBanner.redirectUrl,
                                              //         "_blank"
                                              //       );
                                              //     }
                                              //   }
                                              // }}
                                              style={{
                                                width: "100%",
                                                display: "flex",
                                                borderRadius: "20px",
                                                overflow: "hidden",
                                                height: "170px",
                                              }}
                                            >
                                              <Zoom
                                                key={
                                                  category?.desktopBanner?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                  }}
                                                  src={
                                                    category?.desktopBanner?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.desktopBanner?.altText || ""}
                                                />
                                              </Zoom>
                                            </Box>
                                          </Box>
                                        </div>
                                      </Grid>
                                      <Grid item xs={12} md={6}>
                                        <div className="bento-container">
                                          <Box mb={3}>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Grid for Mobile
                                            </Typography>
                                            <div className="bento-img-container bento-large-small">
                                              <Zoom
                                                key={
                                                  category?.mobileGrid[0]?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  src={
                                                    category?.mobileGrid[0]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.mobileGrid[0]?.altText || ""}
                                                />
                                              </Zoom>
                                              <Zoom
                                                key={
                                                  category?.mobileGrid[1]?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  src={
                                                    category?.mobileGrid[1]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.mobileGrid[1]?.altText || ""}
                                                />
                                              </Zoom>
                                            </div>
                                          </Box>
                                          <Box>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Category Banner For Mobile
                                            </Typography>
                                            <Box
                                              // onClick={() => {
                                              //   if (category?.defaultRedirectUrlEnable) {
                                              //     window.open(category?.defaultGridUrl, "_blank");
                                              //   } else {
                                              //     if (category?.mobileBanner?.redirectUrl) {
                                              //       window.open(
                                              //         category.mobileBanner.redirectUrl,
                                              //         "_blank"
                                              //       );
                                              //     }
                                              //   }
                                              // }}
                                              style={{
                                                width: "100%",
                                                display: "flex",
                                                borderRadius: "20px",
                                                overflow: "hidden",
                                                height: "170px",
                                              }}
                                            >
                                              <Zoom
                                                key={
                                                  category?.mobileBanner?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                  }}
                                                  src={
                                                    category?.mobileBanner?.imageUrl || defaultImage
                                                  }
                                                  alt={category?.mobileBanner?.altText || ""}
                                                />
                                              </Zoom>
                                            </Box>
                                          </Box>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Card>
                        );
                      case "Equal":
                        return (
                          <Card
                            sx={{
                              p: { xs: 2, md: 3 },
                              borderRadius: 2.5,
                              boxShadow: "none",
                              backgroundColor: "#F5F5FF",
                              marginBottom: "15px",
                              position: "relative",
                            }}
                            className="repeat-card"
                          >
                            <Accordion>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panelcategory-06-content"
                                id="panelcategory-06-header"
                              >
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Typography
                                    variant="h4"
                                    fontWeight="semibold"
                                    style={{ color: "#2E2E3A" }}
                                  >
                                    {category?.categoryName}
                                  </Typography>
                                </Box>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid container direction="row" spacing={3} mt={0}>
                                  <Grid item xs={12} style={{ paddingTop: "10px" }}>
                                    <Box>
                                      <Typography
                                        variant="body2"
                                        color="#656575"
                                        mb={1}
                                        style={{ fontSize: "14px" }}
                                      >
                                        Bento Grid Heading (H2)
                                      </Typography>
                                      <Typography variant="h5" fontWeight="medium">
                                        {category?.bentoGridHeading}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Grid container direction="row" spacing={3} mt={0}>
                                      <Grid item xs={12} md={6}>
                                        <div className="bento-container">
                                          <Box mb={3}>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Grid for Desktop
                                            </Typography>
                                            <div className="bento-img-container bento-two">
                                              <Zoom
                                                key={
                                                  category?.desktopGrid[0]?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  src={
                                                    category?.desktopGrid[0]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.desktopGrid[0]?.altText || ""}
                                                />
                                              </Zoom>
                                              <Zoom
                                                key={
                                                  category?.desktopGrid[1]?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  src={
                                                    category?.desktopGrid[1]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.desktopGrid[1]?.altText || ""}
                                                />
                                              </Zoom>
                                            </div>
                                          </Box>
                                          <Box>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Category Banner For Desktop
                                            </Typography>
                                            <Box
                                              style={{
                                                width: "100%",
                                                display: "flex",
                                                borderRadius: "20px",
                                                overflow: "hidden",
                                                height: "170px",
                                              }}
                                              // onClick={() => {
                                              //   if (category?.defaultRedirectUrlEnable) {
                                              //     window.open(category?.defaultGridUrl, "_blank");
                                              //   } else {
                                              //     if (category?.desktopBanner?.redirectUrl) {
                                              //       window.open(
                                              //         category.desktopBanner.redirectUrl,
                                              //         "_blank"
                                              //       );
                                              //     }
                                              //   }
                                              // }}
                                            >
                                              <Zoom
                                                key={
                                                  category?.desktopBanner?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                  }}
                                                  src={
                                                    category?.desktopBanner?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.desktopBanner?.altText || ""}
                                                />
                                              </Zoom>
                                            </Box>
                                          </Box>
                                        </div>
                                      </Grid>
                                      <Grid item xs={12} md={6}>
                                        <div className="bento-container">
                                          <Box mb={3}>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Grid for Mobile
                                            </Typography>
                                            <div className="bento-img-container bento-two">
                                              <Zoom
                                                key={
                                                  category?.mobileGrid[0]?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  src={
                                                    category?.mobileGrid[0]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.mobileGrid[0]?.altText || ""}
                                                />
                                              </Zoom>
                                              <Zoom
                                                key={
                                                  category?.mobileGrid[1]?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  src={
                                                    category?.mobileGrid[1]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.mobileGrid[1]?.altText || ""}
                                                />
                                              </Zoom>
                                            </div>
                                          </Box>
                                          <Box>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Category Banner For Mobile
                                            </Typography>
                                            <Box
                                              style={{
                                                width: "100%",
                                                display: "flex",
                                                borderRadius: "20px",
                                                overflow: "hidden",
                                                height: "170px",
                                              }}
                                              // onClick={() => {
                                              //   if (category?.defaultRedirectUrlEnable) {
                                              //     window.open(category?.defaultGridUrl, "_blank");
                                              //   } else {
                                              //     if (category?.mobileBanner?.redirectUrl) {
                                              //       window.open(
                                              //         category.mobileBanner.redirectUrl,
                                              //         "_blank"
                                              //       );
                                              //     }
                                              //   }
                                              // }}
                                            >
                                              <Zoom
                                                key={
                                                  category?.mobileBanner?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                  }}
                                                  src={
                                                    category?.mobileBanner?.imageUrl || defaultImage
                                                  }
                                                  alt={category?.mobileBanner?.altText || ""}
                                                />
                                              </Zoom>
                                            </Box>
                                          </Box>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Card>
                        );
                      case "Triple Grid":
                        return (
                          <Card
                            sx={{
                              p: { xs: 2, md: 3 },
                              borderRadius: 2.5,
                              boxShadow: "none",
                              backgroundColor: "#F5F5FF",
                              marginBottom: "15px",
                              position: "relative",
                            }}
                            className="repeat-card"
                          >
                            <Accordion>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panelcategory-07-content"
                                id="panelcategory-07-header"
                              >
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Typography
                                    variant="h4"
                                    fontWeight="semibold"
                                    style={{ color: "#2E2E3A" }}
                                  >
                                    {category?.categoryName}
                                  </Typography>
                                </Box>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid container direction="row" spacing={3} mt={0}>
                                  <Grid item xs={12} style={{ paddingTop: "10px" }}>
                                    <Box>
                                      <Typography
                                        variant="body2"
                                        color="#656575"
                                        mb={1}
                                        style={{ fontSize: "14px" }}
                                      >
                                        Bento Grid Heading (H2)
                                      </Typography>
                                      <Typography variant="h5" fontWeight="medium">
                                        {category?.bentoGridHeading}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Grid container direction="row" spacing={3} mt={0}>
                                      <Grid item xs={12} md={6}>
                                        <div className="bento-container">
                                          <Box mb={3}>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Grid for Desktop
                                            </Typography>
                                            <div className="bento-img-container bento-three">
                                              <Zoom
                                                key={
                                                  category?.desktopGrid[0]?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  src={
                                                    category?.desktopGrid[0]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.desktopGrid[0]?.altText || ""}
                                                />
                                              </Zoom>
                                              <Zoom
                                                key={
                                                  category?.desktopGrid[1]?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  src={
                                                    category?.desktopGrid[1]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.desktopGrid[1]?.altText || ""}
                                                />
                                              </Zoom>
                                              <Zoom
                                                key={
                                                  category?.desktopGrid[2]?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  src={
                                                    category?.desktopGrid[2]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.desktopGrid[2]?.altText || ""}
                                                />
                                              </Zoom>
                                            </div>
                                          </Box>
                                          <Box>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Category Banner For Desktop
                                            </Typography>
                                            <Box
                                              // onClick={() => {
                                              //   if (defaultRedirectUrlEnable) {
                                              //     window.open(category?.defaultGridUrl, "_blank");
                                              //   } else {
                                              //     if (category?.desktopBanner?.redirectUrl) {
                                              //       window.open(
                                              //         category.desktopBanner.redirectUrl,
                                              //         "_blank"
                                              //       );
                                              //     }
                                              //   }
                                              // }}
                                              style={{
                                                width: "100%",
                                                display: "flex",
                                                borderRadius: "20px",
                                                overflow: "hidden",
                                                height: "170px",
                                              }}
                                            >
                                              <Zoom
                                                key={
                                                  category?.desktopBanner?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                  }}
                                                  src={
                                                    category?.desktopBanner?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.desktopBanner?.altText || ""}
                                                />
                                              </Zoom>
                                            </Box>
                                          </Box>
                                        </div>
                                      </Grid>
                                      <Grid item xs={12} md={6}>
                                        <div className="bento-container">
                                          <Box mb={3}>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Grid for Mobile
                                            </Typography>
                                            <div className="bento-img-container bento-three">
                                              <Zoom
                                                key={
                                                  category?.mobileGrid[0]?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  src={
                                                    category?.mobileGrid[0]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.mobileGrid[0]?.altText || ""}
                                                />
                                              </Zoom>
                                              <Zoom
                                                key={
                                                  category?.mobileGrid[1]?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  src={
                                                    category?.mobileGrid[1]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.mobileGrid[1]?.altText || ""}
                                                />
                                              </Zoom>
                                              <Zoom
                                                key={
                                                  category?.mobileGrid[2]?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  src={
                                                    category?.mobileGrid[2]?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.mobileGrid[2]?.altText || ""}
                                                />
                                              </Zoom>
                                            </div>
                                          </Box>
                                          <Box>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Category Banner For Mobile
                                            </Typography>
                                            <Box
                                              // onClick={() => {
                                              //   if (defaultRedirectUrlEnable) {
                                              //     window.open(category?.defaultGridUrl, "_blank");
                                              //   } else {
                                              //     if (category?.mobileBanner?.redirectUrl) {
                                              //       window.open(
                                              //         category.mobileBanner.redirectUrl,
                                              //         "_blank"
                                              //       );
                                              //     }
                                              //   }
                                              // }}
                                              style={{
                                                width: "100%",
                                                display: "flex",
                                                borderRadius: "20px",
                                                overflow: "hidden",
                                                height: "170px",
                                              }}
                                            >
                                              <Zoom
                                                key={
                                                  category?.mobileBanner?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                  }}
                                                  src={
                                                    category?.mobileBanner?.imageUrl || defaultImage
                                                  }
                                                  alt={category?.mobileBanner?.altText || ""}
                                                />
                                              </Zoom>
                                            </Box>
                                          </Box>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Card>
                        );
                      case "Slider":
                        return (
                          <Card
                            sx={{
                              p: { xs: 2, md: 3 },
                              borderRadius: 2.5,
                              boxShadow: "none",
                              backgroundColor: "#F5F5FF",
                              marginBottom: "15px",
                              position: "relative",
                            }}
                            className="repeat-card"
                          >
                            <Accordion>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panelcategory-09-content"
                                id="panelcategory-09-header"
                              >
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Typography
                                    variant="h4"
                                    fontWeight="semibold"
                                    style={{ color: "#2E2E3A" }}
                                  >
                                    {category?.categoryName}
                                  </Typography>
                                </Box>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid container direction="row" spacing={3} mt={0}>
                                  <Grid item xs={12} style={{ paddingTop: "10px" }}>
                                    <Box>
                                      <Typography
                                        variant="body2"
                                        color="#656575"
                                        mb={1}
                                        style={{ fontSize: "14px" }}
                                      >
                                        Bento Grid Heading (H2)
                                      </Typography>
                                      <Typography variant="h5" fontWeight="medium">
                                        {category?.bentoGridHeading}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Grid container direction="row" spacing={3} mt={0}>
                                      <Grid item xs={12} md={6}>
                                        <div className="bento-container">
                                          <Box mb={3}>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Grid for Desktop
                                            </Typography>
                                            <div className="bento-img-container bento-three">
                                              {Array.isArray(category?.desktopGrid) &&
                                                category.desktopGrid.map((item, idx) => (
                                                  <Zoom
                                                    key={item?.imageUrl || defaultImage}
                                                    classDialog="custom-zoom"
                                                    style={{ width: "100%" }}
                                                  >
                                                    <img
                                                      key={idx}
                                                      src={item?.imageUrl || defaultImage}
                                                      alt={item?.altText || ""}
                                                    />
                                                  </Zoom>
                                                ))}
                                            </div>
                                          </Box>
                                          <Box>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Category Banner For Desktop
                                            </Typography>
                                            <Box
                                              style={{
                                                width: "100%",
                                                display: "flex",
                                                borderRadius: "20px",
                                                overflow: "hidden",
                                                height: "170px",
                                                cursor: category?.desktopBanner?.redirectUrl
                                                  ? "pointer"
                                                  : "default",
                                              }}
                                              // onClick={() => {
                                              //   if (defaultRedirectUrlEnable) {
                                              //     window.open(category?.defaultGridUrl, "_blank");
                                              //   } else {
                                              //     if (category?.desktopBanner?.redirectUrl) {
                                              //       window.open(
                                              //         category.desktopBanner.redirectUrl,
                                              //         "_blank"
                                              //       );
                                              //     }
                                              //   }
                                              // }}
                                            >
                                              <Zoom
                                                key={
                                                  category?.desktopBanner?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                  }}
                                                  src={
                                                    category?.desktopBanner?.imageUrl ||
                                                    defaultImage
                                                  }
                                                  alt={category?.desktopBanner?.altText || ""}
                                                />
                                              </Zoom>
                                            </Box>
                                          </Box>
                                        </div>
                                      </Grid>
                                      <Grid item xs={12} md={6}>
                                        <div className="bento-container">
                                          <Box mb={3}>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Grid for Mobile
                                            </Typography>
                                            <div className="bento-img-container bento-three">
                                              {Array.isArray(category?.mobileGrid) &&
                                                category.mobileGrid.map((item, idx) => (
                                                  <Zoom
                                                    key={item?.imageUrl || defaultImage}
                                                    classDialog="custom-zoom"
                                                    style={{ width: "100%" }}
                                                  >
                                                    <img
                                                      key={idx}
                                                      src={item?.imageUrl || defaultImage}
                                                      alt={item?.altText || ""}
                                                    />
                                                  </Zoom>
                                                ))}
                                            </div>
                                          </Box>
                                          <Box>
                                            <Typography
                                              variant="body2"
                                              color="#656575"
                                              mb={1}
                                              style={{ fontSize: "14px" }}
                                            >
                                              Category Banner For Mobile
                                            </Typography>
                                            <Box
                                              style={{
                                                width: "100%",
                                                display: "flex",
                                                borderRadius: "20px",
                                                overflow: "hidden",
                                                height: "170px",
                                                cursor: category?.desktopBanner?.redirectUrl
                                                  ? "pointer"
                                                  : "default",
                                              }}
                                              // onClick={() => {
                                              //   if (defaultRedirectUrlEnable) {
                                              //     window.open(category?.defaultGridUrl, "_blank");
                                              //   } else {
                                              //     if (category?.mobileBanner?.redirectUrl) {
                                              //       window.open(
                                              //         category.mobileBanner.redirectUrl,
                                              //         "_blank"
                                              //       );
                                              //     }
                                              //   }
                                              // }}
                                            >
                                              <Zoom
                                                key={
                                                  category?.mobileBanner?.imageUrl || defaultImage
                                                }
                                                style={{ width: "100%" }}
                                                classDialog="custom-zoom"
                                              >
                                                <img
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                  }}
                                                  src={
                                                    category?.mobileBanner?.imageUrl || defaultImage
                                                  }
                                                  alt={category?.mobileBanner?.altText || ""}
                                                />
                                              </Zoom>
                                            </Box>
                                          </Box>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Card>
                        );
                      case "No Grid":
                        return (
                          <Card
                            sx={{
                              p: { xs: 2, md: 3 },
                              borderRadius: 2.5,
                              boxShadow: "none",
                              backgroundColor: "#F5F5FF",
                              marginBottom: "15px",
                              position: "relative",
                            }}
                            className="repeat-card"
                          >
                            <Accordion>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panelcategory-09-content"
                                id="panelcategory-09-header"
                              >
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Typography
                                    variant="h4"
                                    fontWeight="semibold"
                                    style={{ color: "#2E2E3A" }}
                                  >
                                    {category?.categoryName}
                                  </Typography>
                                </Box>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid container direction="row" spacing={3} mt={0}>
                                  <Grid item xs={12} style={{ paddingTop: "10px" }}>
                                    <Box>
                                      <Typography
                                        variant="body2"
                                        color="#656575"
                                        mb={1}
                                        style={{ fontSize: "14px" }}
                                      >
                                        Bento Grid Heading (H2)
                                      </Typography>
                                      <Typography variant="h5" fontWeight="medium">
                                        {category?.bentoGridHeading}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Grid container direction="row" spacing={3} mt={0}>
                                      <Grid item xs={12} md={6}>
                                        <div className="bento-container">
                                          <Typography
                                            variant="body2"
                                            color="#656575"
                                            mb={1}
                                            style={{ fontSize: "14px" }}
                                          >
                                            Grid for Desktop
                                          </Typography>
                                          <Box
                                            display="flex"
                                            flexDirection="column"
                                            alignItems="center"
                                            justifyContent="center"
                                            gap={0.5}
                                            style={{
                                              width: "90px",
                                              height: "90px",
                                              borderRadius: "12px",
                                              padding: "16px 12px",
                                              backgroundColor: "#ffffff",
                                            }}
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="30"
                                              height="30"
                                              viewBox="0 0 30 30"
                                              fill="none"
                                              style={{ margin: "0" }}
                                            >
                                              <path
                                                d="M15 29C22.7170 29 29 22.7198 29 15C29 11.2573 27.5445 7.74109 24.9016 5.09843C22.2583 2.45548 18.7427 1 15 1C7.28023 1 1 7.28023 1 15C1 18.7427 2.45548 22.2589 5.09843 24.9016C7.74109 27.5445 11.2573 29 15 29ZM15 26.6667C12.2736 26.6667 9.69161 25.7398 7.61377 24.036L24.036 7.61377C25.7398 9.69161 26.6667 12.2736 26.6667 15C26.6667 21.4329 21.4329 26.6667 15 26.6667ZM15 3.33333C17.7258 3.33333 20.3084 4.26017 22.3857 5.96403L5.96403 22.3862C4.26017 20.3084 3.33333 17.7264 3.33333 15C3.33333 8.5671 8.5671 3.33333 15 3.33333Z"
                                                fill="#0163FF"
                                                fillOpacity="0.24"
                                              />
                                            </svg>
                                            <Typography
                                              variant="body2"
                                              fontWeight="600"
                                              color="#8A8A98"
                                              style={{ fontSize: "12px" }}
                                            >
                                              No Grid
                                            </Typography>
                                          </Box>
                                        </div>
                                      </Grid>
                                      <Grid item xs={12} md={6}>
                                        <div className="bento-container">
                                          <Typography
                                            variant="body2"
                                            color="#656575"
                                            mb={1}
                                            style={{ fontSize: "14px" }}
                                          >
                                            Grid for Mobile
                                          </Typography>
                                          <Box
                                            display="flex"
                                            flexDirection="column"
                                            alignItems="center"
                                            justifyContent="center"
                                            gap={0.5}
                                            style={{
                                              width: "90px",
                                              height: "90px",
                                              borderRadius: "12px",
                                              padding: "16px 12px",
                                              backgroundColor: "#ffffff",
                                            }}
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="30"
                                              height="30"
                                              viewBox="0 0 30 30"
                                              fill="none"
                                              style={{ margin: "0" }}
                                            >
                                              <path
                                                d="M15 29C22.7170 29 29 22.7198 29 15C29 11.2573 27.5445 7.74109 24.9016 5.09843C22.2583 2.45548 18.7427 1 15 1C7.28023 1 1 7.28023 1 15C1 18.7427 2.45548 22.2589 5.09843 24.9016C7.74109 27.5445 11.2573 29 15 29ZM15 26.6667C12.2736 26.6667 9.69161 25.7398 7.61377 24.036L24.036 7.61377C25.7398 9.69161 26.6667 12.2736 26.6667 15C26.6667 21.4329 21.4329 26.6667 15 26.6667ZM15 3.33333C17.7258 3.33333 20.3084 4.26017 22.3857 5.96403L5.96403 22.3862C4.26017 20.3084 3.33333 17.7264 3.33333 15C3.33333 8.5671 8.5671 3.33333 15 3.33333Z"
                                                fill="#0163FF"
                                                fillOpacity="0.24"
                                              />
                                            </svg>
                                            <Typography
                                              variant="body2"
                                              fontWeight="600"
                                              color="#8A8A98"
                                              style={{ fontSize: "12px" }}
                                            >
                                              No Grid
                                            </Typography>
                                          </Box>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Card>
                        );
                        return (
                          <Card
                            sx={{
                              p: { xs: 2, md: 3 },
                              borderRadius: 2.5,
                              boxShadow: "none",
                              backgroundColor: "#F5F5FF",
                              marginBottom: "15px",
                              position: "relative",
                            }}
                            className="repeat-card"
                          >
                            <Accordion>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panelcategory-09-content"
                                id="panelcategory-09-header"
                              >
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Typography
                                    variant="h4"
                                    fontWeight="semibold"
                                    style={{ color: "#2E2E3A" }}
                                  >
                                    {category?.categoryName}
                                  </Typography>
                                </Box>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid container direction="row" spacing={3} mt={0}>
                                  <Grid item xs={12} style={{ paddingTop: "10px" }}>
                                    <Box>
                                      <Typography
                                        variant="body2"
                                        color="#656575"
                                        mb={1}
                                        style={{ fontSize: "14px" }}
                                      >
                                        Bento Grid Heading(H2)
                                      </Typography>
                                      <Typography variant="h5" fontWeight="medium">
                                        {category?.bentoGridHeading}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12}>
                                    <div className="bento-container">
                                      <Typography
                                        variant="body2"
                                        color="#656575"
                                        mb={1}
                                        style={{ fontSize: "14px" }}
                                      >
                                        Grid Style
                                      </Typography>
                                      <Box
                                        display="flex"
                                        flexDirection="column"
                                        alignItems="center"
                                        justifyContent="center"
                                        gap={0.5}
                                        style={{
                                          width: "90px",
                                          height: "90px",
                                          borderRadius: "12px",
                                          padding: "16px 12px",
                                          backgroundColor: "#ffffff",
                                        }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="30"
                                          height="30"
                                          viewBox="0 0 30 30"
                                          fill="none"
                                          style={{ margin: "0" }}
                                        >
                                          <path
                                            d="M15 29C22.7192 29 29 22.7198 29 15C29 11.2573 27.5445 7.74109 24.9016 5.09843C22.2583 2.45548 18.7427 1 15 1C7.28023 1 1 7.28023 1 15C1 18.7427 2.45548 22.2589 5.09843 24.9016C7.74109 27.5445 11.2573 29 15 29ZM15 26.6667C12.2736 26.6667 9.69161 25.7398 7.61377 24.036L24.036 7.61377C25.7398 9.69161 26.6667 12.2736 26.6667 15C26.6667 21.4329 21.4329 26.6667 15 26.6667ZM15 3.33333C17.7258 3.33333 20.3084 4.26017 22.3857 5.96403L5.96403 22.3862C4.26017 20.3084 3.33333 17.7264 3.33333 15C3.33333 8.5671 8.5671 3.33333 15 3.33333Z"
                                            fill="#0163FF"
                                            fillOpacity="0.24"
                                          />
                                        </svg>
                                        <Typography
                                          variant="body2"
                                          fontWeight="600"
                                          color="#8A8A98"
                                          style={{ fontSize: "12px" }}
                                        >
                                          No Grid
                                        </Typography>
                                      </Box>
                                    </div>
                                  </Grid>
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Card>
                        );
                    }
                  })}
              </AccordionDetails>
            </Accordion>

            {/********************** Customer Reviews Section **********************/}
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panelCustomerReviews-content"
                id="panelCustomerReviews-header"
              >
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography variant="h4" fontWeight="semibold" style={{ color: "#2E2E3A" }}>
                    Customer Reviews
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container direction="row" spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body2" color="#656575" mb={1} style={{ fontSize: "14px" }}>
                      Section Title (H2)
                    </Typography>
                    <Typography variant="h5" fontWeight="medium">
                      {formData?.customerReviews ? formData?.customerReviews : "-"}
                    </Typography>
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            {/********************** California's Favorite Cannabis Delivery Section **********************/}
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panelCaliforniaFavoriteCannabisDelivery-content"
                id="panelCaliforniaFavoriteCannabisDelivery-header"
              >
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography variant="h4" fontWeight="semibold" style={{ color: "#2E2E3A" }}>
                    {isDefaultHomePage
                      ? "Favorite Cannabis Delivery"
                      : `${stateName}'s Favorite Cannabis Delivery`}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container direction="row" spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body2" color="#656575" mb={1} style={{ fontSize: "14px" }}>
                      Section Title (H2)
                    </Typography>
                    <Typography variant="h5" fontWeight="medium">
                      {formData?.deliverySection?.sectionTitle
                        ? formData?.deliverySection?.sectionTitle
                        : "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Typography variant="body2" color="#656575" mb={1} style={{ fontSize: "14px" }}>
                      Paragraph (P)
                    </Typography>
                    <Typography variant="h5" fontWeight="medium">
                      {formData?.deliverySection?.sectionPara
                        ? formData.deliverySection.sectionPara
                        : "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Grid container direction="row" spacing={4}>
                      {formData.deliverySection.subData.length === 0 && (
                        <Box
                          sx={{
                            mt: 8,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            width: "100%",
                          }}
                        >
                          <NoDataFound />
                        </Box>
                      )}

                      {formData?.deliverySection?.subData?.map((item, index) => (
                        <Grid item xs={12} md={4} key={index}>
                          <Card
                            sx={{
                              p: { xs: 2 },
                              borderRadius: 2.5,
                              boxShadow: "none",
                              backgroundColor: "#F5F5FF",
                              height: "100%",
                            }}
                          >
                            <Box display="flex" alignItems="center" gap={2} mb={3}>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                borderRadius="12px"
                                border="1px solid #ffffff"
                                backgroundColor="#FFF7E0"
                                width="70px"
                                height="70px"
                                className="zoom-ing-container"
                              >
                                <Zoom
                                  key={item.image}
                                  classDialog="custom-zoom"
                                  style={{ width: "100%" }}
                                >
                                  <img width="35px" height="35px" src={item.image} alt="" style={{ objectFit: "contain" }} />
                                </Zoom>
                              </Box>
                              <Box display="flex" flexDirection="column">
                                <Typography variant="body2" color="#2E2E3A" fontWeight="600">
                                  {item.heading || "Weed at your door in"}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="#2E2E3A"
                                  fontWeight="400"
                                  style={{ fontSize: "14px" }}
                                >
                                  {item.subHeading}
                                </Typography>
                              </Box>
                            </Box>
                            <Typography variant="body2" color="#2E2E3A" fontWeight="400">
                              {item.paragraph}
                            </Typography>
                          </Card>
                        </Grid>
                      ))}
                      {/* <Grid item xs={12} md={4}>
                      <Card
                        sx={{
                          p: { xs: 2 },
                          borderRadius: 2.5,
                          boxShadow: "none",
                          backgroundColor: "#F5F5FF",
                          height: "100%",
                        }}
                      >
                        <Box display="flex" alignItems="center" gap={2} mb={3}>
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            borderRadius="12px"
                            border="1px solid #ffffff"
                            backgroundColor="#FFF7E0"
                            width="70px"
                            height="70px"
                          >
                            <img
                              width="35px"
                              height="35px"
                              src="https://hyperwolf.com/images/icon-free-delivery.svg"
                              alt=""
                            />
                          </Box>
                          <Box display="flex" flexDirection="column">
                            <Typography
                              variant="body2"
                              color="#2E2E3A"
                              fontWeight="400"
                              style={{ fontSize: "14px" }}
                            >
                              Free Delivery
                            </Typography>
                            <Typography variant="body2" color="#2E2E3A" fontWeight="600">
                              With every order
                            </Typography>
                          </Box>
                        </Box>
                        <Typography variant="body2" color="#2E2E3A" fontWeight="400">
                          You heard that right. With an order minimum of only $50, you get free
                          delivery and no other hidden fees.. You can easily pay with cash or card
                          as long as you are over 21 and have a valid ID. We&apos;re dedicated to
                          making weed delivery near you as easy and affordable as possible.
                        </Typography>
                      </Card>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Card
                        sx={{
                          p: { xs: 2 },
                          borderRadius: 2.5,
                          boxShadow: "none",
                          backgroundColor: "#F5F5FF",
                          height: "100%",
                        }}
                      >
                        <Box display="flex" alignItems="center" gap={2} mb={3}>
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            borderRadius="12px"
                            border="1px solid #ffffff"
                            backgroundColor="#FFF7E0"
                            width="70px"
                            height="70px"
                          >
                            <img
                              width="35px"
                              height="35px"
                              src="https://hyperwolf.com/images/icon-at-the-best-price.svg"
                              alt=""
                            />
                          </Box>
                          <Box display="flex" flexDirection="column">
                            <Typography variant="body2" color="#2E2E3A" fontWeight="600">
                              The best cannabis products
                            </Typography>
                            <Typography
                              variant="body2"
                              color="#2E2E3A"
                              fontWeight="400"
                              style={{ fontSize: "14px" }}
                            >
                              At the best price
                            </Typography>
                          </Box>
                        </Box>
                        <Typography variant="body2" color="#2E2E3A" fontWeight="400">
                          Our roots run deep in the industry, so we&apos;re always on the cutting
                          edge of new strains and brands. Our consioussers curate an incredible
                          selection of top-quality, hand-picked ﬂowers, pre-rolls, concentrates,
                          cartridges, edibles and more.
                        </Typography>
                      </Card>
                    </Grid> */}
                    </Grid>
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
            {/* ******************************* Content Section ****************** */}
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="paneltopesection-content"
                id="paneltopesection-header"
              >
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography variant="h4" fontWeight="semibold" style={{ color: "#2E2E3A" }}>
                    Content Section
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container direction="row" spacing={3}>
                  {!formData?.stateParagraph ? (
                    <Grid item xs={12} md={12}>
                      <Typography variant="h5" fontWeight="medium">
                        -
                      </Typography>
                    </Grid>
                  ) : (
                    <Grid item xs={12} md={12}>
                      <div
                        style={{ maxHeight: "400px", overflow: "auto" }}
                        dangerouslySetInnerHTML={{
                          __html: formData?.stateParagraph,
                        }}
                      ></div>
                    </Grid>
                  )}
                </Grid>
              </AccordionDetails>
            </Accordion>

            {/********************** FAQ **********************/}
            <Accordion className="home-page-faq">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panelfaqSection-content"
                id="panelfaqSection-header"
              >
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography variant="h4" fontWeight="semibold" style={{ color: "#2E2E3A" }}>
                    {"FAQs"}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container direction="row" spacing={1.5} className="multi-state-faq">
                  {formData.faqSection.subData.length === 0 && (
                    <Box
                      sx={{
                        mt: 8,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        width: "100%",
                      }}
                    >
                      <NoDataFound />
                    </Box>
                  )}

                  {formData?.faqSection?.subData?.map((item, index) => (
                    <Grid item xs={12} key={index}>
                      <Box pb={1.5}>
                        <Typography variant="body2" color="#2E2E3A" fontWeight="600" mb={0.5}>
                          {quillToPlainText(item.question)}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="#2E2E3A"
                          fontWeight="400"
                          style={{ fontSize: "14px" }}
                        >
                          {quillToPlainText(item.answer)}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                  {/* <Grid item xs={12}>
                  <Typography variant="body2" color="#2E2E3A" fontWeight="600" mb={0.5}>
                    {stateName}&apos;s Favorite Cannabis Delivery
                  </Typography>
                  <Typography
                    variant="body2"
                    color="#2E2E3A"
                    fontWeight="400"
                    style={{ fontSize: "14px" }}
                  >
                    Like a wolf in sheep&apos;s clothing, HyperWolf is coming to a California
                    neighborhood near you to deliver premium cannabis products including flower,
                    vapes, pre-rolled joints and blunts, edibles, concentrates, and accessories. Our
                    fleet of unmarked cars will discreetly deliver high quality cannabis anywhere in
                    the Inland Empire.
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" color="#2E2E3A" fontWeight="600" mb={0.5}>
                    {stateName}&apos;s Favorite Cannabis Delivery
                  </Typography>
                  <Typography
                    variant="body2"
                    color="#2E2E3A"
                    fontWeight="400"
                    style={{ fontSize: "14px" }}
                  >
                    Like a wolf in sheep&apos;s clothing, HyperWolf is coming to a California
                    neighborhood near you to deliver premium cannabis products including flower,
                    vapes, pre-rolled joints and blunts, edibles, concentrates, and accessories. Our
                    fleet of unmarked cars will discreetly deliver high quality cannabis anywhere in
                    the Inland Empire.
                  </Typography>
                </Grid> */}
                </Grid>
              </AccordionDetails>
            </Accordion>

            {/********************** Footer Section **********************/}
            <Accordion className="home-page-faq" style={{ marginBottom: "16px" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panelFooter-content"
                id="panelFooter-header"
              >
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography variant="h4" fontWeight="semibold" style={{ color: "#2E2E3A" }}>
                    Footer Section
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Box sx={{ width: "100%" }}>
                  <Grid container direction="row" spacing={4}>
                    {formData?.footerSection?.menusItems?.overView?.isActive && (
                      <Grid item xs={12} md={3}>
                        <Card
                          sx={{
                            p: { xs: 2, md: 3 },
                            borderRadius: 2.5,
                            boxShadow: "none",
                            backgroundColor: "#F5F5FF",
                          }}
                        >
                          <List
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                              gap: "12px",
                              padding: "0",
                            }}
                          >
                            <ListItem style={{ flexDirection: "column", gap: "30px" }}>
                              <Box
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "12px",
                                }}
                              >
                                <Box>
                                  <Typography
                                    variant="body2"
                                    color="#656575"
                                    mb={1}
                                    style={{ fontSize: "14px" }}
                                  >
                                    Menu Title (H4)
                                  </Typography>
                                  <Typography variant="body2" color="#2E2E3A">
                                    {/* Overview */}
                                    {formData?.footerSection?.menusItems?.overView?.name}
                                  </Typography>
                                </Box>
                                {formData?.footerSection?.menusItems?.overView?.subData?.cta1
                                  ?.label && (
                                  <Typography
                                    variant="body2"
                                    color="#2E2E3A"
                                    mb={1}
                                    style={{
                                      padding: "8px",
                                      borderRadius: "12px",
                                      border: "1px solid #000000",
                                      fontSize: "14px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {formData.footerSection.menusItems.overView.subData.cta1.label}
                                    {/* View All Delivery Areas in Southern California */}
                                  </Typography>
                                )}
                                {formData?.footerSection?.menusItems?.overView?.subData?.cta2
                                  ?.label && (
                                  <Typography
                                    variant="body2"
                                    color="#2E2E3A"
                                    mb={1}
                                    style={{
                                      padding: "8px",
                                      borderRadius: "12px",
                                      border: "1px solid #000000",
                                      fontSize: "14px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {formData.footerSection.menusItems.overView.subData.cta2.label}
                                    {/* Shop Products - Nationwide */}
                                  </Typography>
                                )}
                              </Box>
                              <Box
                                style={{ width: "100%", display: "flex", flexDirection: "column" }}
                              >
                                <Typography
                                  variant="body2"
                                  color="#656575"
                                  mb={1}
                                  style={{ fontSize: "14px" }}
                                >
                                  Paragraph
                                </Typography>
                                {/* <Typography variant="body2" fontWeight="400" color="#2E2E3A">
                                  {/* {quillToPlainText(
                                    formData.footerSection.menusItems.overView.subData.description
                                  )} */}
                                {/* </Typography> */}
                                {!formData?.footerSection?.menusItems?.overView?.subData
                                  ?.description ? (
                                  <Grid item xs={12} md={12}>
                                    <Typography variant="h5" fontWeight="medium">
                                      -
                                    </Typography>
                                  </Grid>
                                ) : (
                                  <Grid item xs={12} md={12}>
                                    <div
                                      style={{ maxHeight: "400px", overflow: "auto" }}
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          formData?.footerSection?.menusItems?.overView?.subData
                                            ?.description,
                                      }}
                                    ></div>
                                  </Grid>
                                )}

                                {/* <Typography
                                  variant="caption"
                                  sx={{
                                    fontSize: "12px",
                                    color: "#8a8a8a",
                                    lineHeight: 1.6,
                                    mb: 0.5,
                                    "& strong": {
                                      color: "#f5c400", // yellow label
                                      fontWeight: 600,
                                    },
                                  }}
                                >
                                  <strong>C.A. LICENSE #:</strong> C12-0000103
                                </Typography>

                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontSize: "11px",
                                    color: "#6f6f6f",
                                    lineHeight: 1.6,
                                    textTransform: "uppercase",
                                    maxWidth: "300px",
                                  }}
                                >
                                  YOU MUST BE 21 YEARS OF AGE OR OLDER TO VIEW OR SUBMIT INFORMATION
                                  TO HYPERWOLF.COM
                                </Typography> */}
                              </Box>
                            </ListItem>
                          </List>
                        </Card>
                      </Grid>
                    )}
                    {formData?.footerSection?.menusItems?.siteMap?.isActive && (
                      <Grid item xs={12} md={3}>
                        <Card
                          sx={{
                            p: { xs: 2, md: 3 },
                            borderRadius: 2.5,
                            boxShadow: "none",
                            backgroundColor: "#F5F5FF",
                          }}
                        >
                          <Box
                            style={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "column",
                              gap: "24px",
                            }}
                          >
                            <Box>
                              <Typography
                                variant="body2"
                                color="#656575"
                                mb={1}
                                style={{ fontSize: "14px" }}
                              >
                                Menu Title (H4)
                              </Typography>
                              <Typography variant="body2" color="#2E2E3A">
                                {/* Site Map */}
                                {formData?.footerSection?.menusItems?.siteMap?.name}
                              </Typography>
                            </Box>
                            <Box>
                              {formData?.footerSection?.menusItems?.siteMap?.subData?.length >
                                0 && (
                                <>
                                  <Typography
                                    variant="body2"
                                    color="#656575"
                                    mb={1}
                                    style={{ fontSize: "14px" }}
                                  >
                                    Items
                                  </Typography>
                                </>
                              )}
                              <List
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-start",
                                  gap: "6px",
                                  padding: "0",
                                }}
                              >
                                {formData?.footerSection?.menusItems?.siteMap?.subData?.map(
                                  (item, index) => (
                                    <ListItem
                                      key={index}
                                      style={{
                                        gap: "16px",
                                        borderRadius: "12px",
                                        background: "#ffffff",
                                        padding: "12px",
                                      }}
                                    >
                                      <Box
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px",
                                        }}
                                      >
                                        <ListItemIcon style={{ minWidth: "auto" }}>
                                          {item.icon && (
                                            <Zoom key={item.icon} classDialog="custom-zoom">
                                              <img
                                                src={item.icon}
                                                alt="item.icon"
                                                style={{
                                                  width: "32px",
                                                  height: "32px",
                                                  objectFit: "contain",
                                                }}
                                              />
                                            </Zoom>
                                          )}
                                        </ListItemIcon>
                                        <Typography
                                          variant="body2"
                                          fontWeight="500"
                                          color="#2E2E3A"
                                          style={{ fontSize: "14px" }}
                                        >
                                          {item.label}
                                        </Typography>
                                      </Box>
                                    </ListItem>
                                  )
                                )}
                              </List>
                            </Box>
                          </Box>
                        </Card>
                      </Grid>
                    )}
                    {formData?.footerSection?.menusItems?.traits?.isActive && (
                      <Grid item xs={12} md={3}>
                        <Card
                          sx={{
                            p: { xs: 2, md: 3 },
                            borderRadius: 2.5,
                            boxShadow: "none",
                            backgroundColor: "#F5F5FF",
                          }}
                        >
                          <Box
                            style={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "column",
                              gap: "24px",
                            }}
                          >
                            <Box>
                              <Typography
                                variant="body2"
                                color="#656575"
                                mb={1}
                                style={{ fontSize: "14px" }}
                              >
                                Menu Title (H4)
                              </Typography>
                              <Typography variant="body2" color="#2E2E3A">
                                {/* Traits */}
                                {formData?.footerSection?.menusItems?.traits?.name}
                              </Typography>
                            </Box>
                            <Box>
                              {formData?.footerSection?.menusItems?.traits?.subData?.length > 0 && (
                                <>
                                  <Typography
                                    variant="body2"
                                    color="#656575"
                                    mb={1}
                                    style={{ fontSize: "14px" }}
                                  >
                                    Items
                                  </Typography>
                                </>
                              )}
                              <List
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-start",
                                  gap: "6px",
                                  padding: "0",
                                }}
                              >
                                {formData?.footerSection?.menusItems?.traits?.subData?.map(
                                  (item, index) => (
                                    <ListItem
                                      key={index}
                                      style={{
                                        gap: "16px",
                                        borderRadius: "12px",
                                        background: "#ffffff",
                                        padding: "12px",
                                      }}
                                    >
                                      <Box
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px",
                                        }}
                                      >
                                        <ListItemIcon style={{ minWidth: "auto" }}>
                                          {item.icon && (
                                            <Zoom key={item.icon} classDialog="custom-zoom">
                                              <img
                                                src={item.icon}
                                                alt="item.icon"
                                                style={{
                                                  width: "32px",
                                                  height: "32px",
                                                  objectFit: "contain",
                                                }}
                                              />
                                            </Zoom>
                                          )}
                                        </ListItemIcon>
                                        <Typography
                                          variant="body2"
                                          fontWeight="500"
                                          color="#2E2E3A"
                                          style={{ fontSize: "14px" }}
                                        >
                                          {item.label}
                                        </Typography>
                                      </Box>
                                    </ListItem>
                                  )
                                )}
                              </List>
                            </Box>
                          </Box>
                        </Card>
                      </Grid>
                    )}

                    <Grid item xs={12} md={3}>
                      <Grid container direction="column" spacing={4}>
                        {formData?.footerSection?.menusItems?.findYourCareer?.isActive && (
                          <Grid item xs={12}>
                            <Card
                              sx={{
                                p: { xs: 2, md: 3 },
                                borderRadius: 2.5,
                                boxShadow: "none",
                                backgroundColor: "#F5F5FF",
                              }}
                            >
                              <Box
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "24px",
                                }}
                              >
                                <Box>
                                  <Typography
                                    variant="body2"
                                    color="#656575"
                                    mb={1}
                                    style={{ fontSize: "14px" }}
                                  >
                                    Menu Title (H4)
                                  </Typography>
                                  <Typography variant="body2" color="#2E2E3A">
                                    {/* Find Your Career */}
                                    {formData?.footerSection?.menusItems?.findYourCareer?.name}
                                  </Typography>
                                </Box>
                                <Box>
                                  {formData?.footerSection?.menusItems?.findYourCareer?.subData
                                    ?.length > 0 && (
                                    <>
                                      <Typography
                                        variant="body2"
                                        color="#656575"
                                        mb={1}
                                        style={{ fontSize: "14px" }}
                                      >
                                        Items
                                      </Typography>
                                    </>
                                  )}
                                  <List
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "flex-start",
                                      gap: "6px",
                                      padding: "0",
                                    }}
                                  >
                                    {formData?.footerSection?.menusItems?.findYourCareer?.subData?.map(
                                      (item, index) => (
                                        <ListItem
                                          key={index}
                                          style={{
                                            gap: "16px",
                                            borderRadius: "12px",
                                            background: "#ffffff",
                                            padding: "12px",
                                          }}
                                        >
                                          <Box
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "8px",
                                            }}
                                          >
                                            <ListItemIcon style={{ minWidth: "auto" }}>
                                              {item.icon && (
                                                <Zoom key={item.icon} classDialog="custom-zoom">
                                                  <img
                                                    src={item.icon}
                                                    alt="item.icon"
                                                    style={{
                                                      width: "32px",
                                                      height: "32px",
                                                      objectFit: "contain",
                                                    }}
                                                  />
                                                </Zoom>
                                              )}
                                            </ListItemIcon>
                                            <Typography
                                              variant="body2"
                                              fontWeight="500"
                                              color="#2E2E3A"
                                              style={{ fontSize: "14px" }}
                                            >
                                              {item.label}
                                            </Typography>
                                          </Box>
                                        </ListItem>
                                      )
                                    )}
                                  </List>
                                </Box>
                              </Box>
                            </Card>
                          </Grid>
                        )}
                        {formData?.footerSection?.menusItems?.quickLinks?.isActive && (
                          <Grid item xs={12}>
                            <Card
                              sx={{
                                p: { xs: 2, md: 3 },
                                borderRadius: 2.5,
                                boxShadow: "none",
                                backgroundColor: "#F5F5FF",
                              }}
                            >
                              <Box
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "24px",
                                }}
                              >
                                <Box>
                                  <Typography
                                    variant="body2"
                                    color="#656575"
                                    mb={1}
                                    style={{ fontSize: "14px" }}
                                  >
                                    Menu Title (H4)
                                  </Typography>
                                  <Typography variant="body2" color="#2E2E3A">
                                    {/* Quick Links */}
                                    {formData?.footerSection?.menusItems?.quickLinks?.name}
                                  </Typography>
                                </Box>
                                <Box>
                                  {formData?.footerSection?.menusItems?.quickLinks?.subData
                                    ?.length > 0 && (
                                    <>
                                      <Typography
                                        variant="body2"
                                        color="#656575"
                                        mb={1}
                                        style={{ fontSize: "14px" }}
                                      >
                                        Items
                                      </Typography>
                                    </>
                                  )}
                                  <List
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "flex-start",
                                      gap: "6px",
                                      padding: "0",
                                    }}
                                  >
                                    {formData?.footerSection?.menusItems?.quickLinks?.subData?.map(
                                      (item, index) => (
                                        <ListItem
                                          key={index}
                                          style={{
                                            gap: "16px",
                                            borderRadius: "12px",
                                            background: "#ffffff",
                                            padding: "12px",
                                          }}
                                        >
                                          <Box
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "8px",
                                            }}
                                          >
                                            <ListItemIcon style={{ minWidth: "auto" }}>
                                              {item.icon && (
                                                <Zoom key={item.icon} classDialog="custom-zoom">
                                                  <img
                                                    src={item.icon}
                                                    alt="item.icon"
                                                    style={{
                                                      width: "32px",
                                                      height: "32px",
                                                      objectFit: "contain",
                                                    }}
                                                  />
                                                </Zoom>
                                              )}
                                            </ListItemIcon>
                                            <Typography
                                              variant="body2"
                                              fontWeight="500"
                                              color="#2E2E3A"
                                              style={{ fontSize: "14px" }}
                                            >
                                              {item.label}
                                            </Typography>
                                          </Box>
                                        </ListItem>
                                      )
                                    )}
                                  </List>
                                </Box>
                              </Box>
                            </Card>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>

                  <Box mt={4}>
                    <Typography variant="body2" color="#656575" mb={1} style={{ fontSize: "14px" }}>
                      Warning Paragraph
                    </Typography>
                    {/* <Typography variant="body2" color="#2E2E3A" fontWeight="400">
                      {quillToPlainText(formData.footerSection.paragraph)}
                    </Typography> */}
                    <Grid item xs={12} md={12}>
                      <div
                        style={{ maxHeight: "400px", overflow: "auto" }}
                        dangerouslySetInnerHTML={{
                          __html: formData?.footerSection?.paragraph,
                        }}
                      ></div>
                    </Grid>
                  </Box>

                  <Card
                    sx={{
                      p: { xs: 2, md: 3 },
                      borderRadius: 2.5,
                      boxShadow: "none",
                      backgroundColor: "#F5F5FF",
                      position: "relative",
                      marginTop: "30px",
                    }}
                  >
                    <Grid container direction="row" spacing={4}>
                      <Grid item xs={12} md={12}>
                        <Typography
                          variant="body2"
                          fontWeight="medium"
                          color="#9A9AAF"
                          style={{ fontSize: "14px" }}
                          mb={1}
                        >
                          Locations
                        </Typography>
                        <List
                          style={{
                            display: "grid",
                            flexDirection: "column",
                            gridTemplateColumns: "1fr 1fr 1fr 1fr",
                            columnGap: "12px",
                            rowGap: "20px",
                            padding: "0",
                          }}
                        >
                          {formData.footerSection.locationList.map((item, index) => (
                            <ListItem
                              key={index}
                              style={{
                                padding: "12px",
                                borderRadius: "12px",
                                background: "#ffffff",
                              }}
                            >
                              <Typography
                                variant="body2"
                                fontWeight="400"
                                color="#2E2E3A"
                                style={{ fontSize: "14px" }}
                              >
                                {item.locationName}
                              </Typography>
                            </ListItem>
                          ))}
                        </List>
                      </Grid>
                    </Grid>
                  </Card>
                </Box>
              </AccordionDetails>
            </Accordion>
          </Box>
        </Grid>
      )}
    </CommonLayout>
  );
}
